export const CONTRACT_RENEW_CONFIRM_INTRO = "就在此之前您已签署的业务合作，现正式告知您：";

export const CONTRACT_RENEW_CONFIRM_ITEMS = [
  "自2026年9月1日开始结算标准变更为：“乙方带来签约的前5单，1对1产品有效用户新签所得可分配收益的18%为乙方分成收入，剩余部分为甲方分成收入；第6单及以上1对1产品有效用户新签所得可分配收益的23%为乙方分成收入，剩余部分为甲方分成收入，甲方无需向乙方支付额外费用。您2026年9月1日前带来的有效用户新签可累计计算单量。",
  "您不得向有效用户直接或变相给予返现、福利、回扣、礼品、代金券、差价补贴、红包、话费减免等任何形式额外利益；若您违反本条约定向有效用户给予额外利益折现金额达到该有效用户对应订单可分配收益的5%及以上的，本公司有权拒绝支付该违规有效用户对应的全部分成收入，由此给本公司造成损失的（包括但不限于本公司定价体系破坏、客户投诉），您应当全额赔偿。",
];

export const CONTRACT_RENEW_CONFIRM_QUESTION = "具体变更内容详见《下单确认件（CPS）》，您是否同意前述变更？";
export const COMPANY_SEAL_URL =
  "https://web-data.zmlearn.com/image/msqst3w7tTNZwsd4yCTmpL/%E9%80%8F%E6%98%8E.png";

export const canViewContract = (company?: { paymentMethodDesc?: string }) =>
  company?.paymentMethodDesc === "线上结算";

export const isPendingContractRenewal = (company?: {
  signStatusDesc?: string;
  contractRenewStatus?: number;
  paymentMethodDesc?: string;
}) =>
  company?.signStatusDesc === "已签约" &&
  company?.contractRenewStatus === 0 &&
  company?.paymentMethodDesc === "线上结算";
